import { AwayPlayerComponent } from './AwayPlayerComponent';
const NOT_IMPLEMENTED = (name) => console.warn("AwayFL loader does not support " + name);
const scriptSrc = document.currentScript.src;
const global = window;
let AWAY_EMBED_CFG;
if (global.swfObject || global.SWFObject || global.swfobject) {
    console.warn("Replace `swfObject` with AwayFl loader!");
}
function createRuntimeFrame(swfUrl, target, width, height) {
    if (!global.AWAY_EMBED_CFG) {
        console.info('AwayFL configuration not found. To set custom options, define a `AWAY_EMBED_CFG` object as explained in the Readme');
        global.AWAY_EMBED_CFG = {};
    }
    AWAY_EMBED_CFG = global.AWAY_EMBED_CFG;
    const player = new AwayPlayerComponent();
    player.src = swfUrl;
    player.width = width;
    player.height = height;
    let baseUrl = AWAY_EMBED_CFG.runtimeBaseUrl;
    if (baseUrl) {
        player.runtimeBaseUrl = baseUrl;
    }
    const id = target.id;
    const name = target.className;
    const parent = target.parentElement;
    target.id = null;
    target.className = '';
    player.id = id;
    player.className = name;
    parent.replaceChild(player, target);
    return player;
}
function embedSWF(swfUrl, targetId, widthStr, heightStr, _version, _xiSwfUrlStr, _flashvarsObj, _parObj, _attObj, callbackFn) {
    const ref = typeof targetId == 'string' ? document.getElementById(targetId) : targetId;
    const frame = createRuntimeFrame(swfUrl, ref, widthStr, heightStr);
    frame.onload = () => {
        callbackFn && callbackFn({
            success: true,
            ref: frame,
            id: ref.id,
        });
    };
}
;
document.addEventListener('load', () => {
});
const swfObject = {
    registerObject: () => NOT_IMPLEMENTED("registerObject"),
    getObjectById: () => NOT_IMPLEMENTED("getObjectById"),
    switchOffAutoHideShow: () => NOT_IMPLEMENTED("switchOffAutoHideShow"),
    enableUriEncoding: () => NOT_IMPLEMENTED("enableUriEncoding"),
    getFlashPlayerVersion: () => NOT_IMPLEMENTED("getFlashPlayerVersion"),
    createSWF: () => NOT_IMPLEMENTED("createSWF"),
    showExpressInstall: () => NOT_IMPLEMENTED("showExpressInstall"),
    createCSS: () => NOT_IMPLEMENTED("createCSS"),
    getQueryParamValue: () => NOT_IMPLEMENTED("getQueryParamValue"),
    get ua() {
        return NOT_IMPLEMENTED('ua');
    },
    embedSWF
};
global.swfObject = swfObject;
global.SWFObject = swfObject;
global.swfobject = swfObject;
